export default __webpack_public_path__ + "b424d39ac3f6e7ad39f23bc4bcbfa2b7.png";